export default __webpack_public_path__ + "static/media/illi2.982bdbc9.png";